export const loadConfig = async (env) => {
  const filePath = `${process.env.PUBLIC_URL}/config/config.${env}.json`;
  const response = await fetch(filePath);
  if (!response.ok) {
    throw new Error(`Failed to load config for environment: ${env}`);
  }
  return response.json();
};
